import { Box, Button, FormControlLabel, MenuItem, Select, Switch, TextField } from '@mui/material'
import Loader from 'components/Loader'
import React, { useEffect, useState } from 'react'
import { styled } from '@mui/material/styles';
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { menuActive } from 'store/menuSlice'
import person from '../../assets/icons/person1.svg'
import add from '../../assets/icons/add_white.svg'
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import ModalContactPromoter from 'components/modal/healthPromotion/ModalContactPromoter';
import { useSelector } from 'react-redux';
import styles from './promote.module.css'
import * as api from '../services/api'

function ManagePromote() {

    const auth = useSelector((state) => state.auth.user_data)
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const [loading, setLoading] = useState(false)

    const [search, setSearch] = useState('')
    const [optionYear, setOptionYear] = useState([])
    const [year_, setYear_] = useState(new Date().getFullYear())
    const [projectList, setProjectList] = useState([])

    const [openModalContact, setOpenModalContact] = useState(false)
    const [role, setRole] = useState(auth['permission']['group_code'])

    const [projectDetail, setProjectDetail] = useState(null)

    const optionsAdmin = [
        'แก้ไข',
        'ดูรายชื่อผู้เข้าร่วมทั้งหมด',
        'คัดกรองผู้เข้าร่วมโครงการ',
        'ติดต่อนักสร้างเสริม'
    ];

    const optionsPromote = [
        'ดูรายชื่อผู้เข้าร่วมทั้งหมด',
        'คัดกรองผู้เข้าร่วมโครงการ',
        'ติดต่อแอดมิน'
    ];

    const ITEM_HEIGHT = 4;
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event, item) => {
        setProjectDetail(item)
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    const handleClickOption = (e) => {
        let { textContent } = e.target
        if (textContent == 'แก้ไข') {
            navigate('/editProjectPromote', { state: { item: projectDetail } })
        } else if (textContent == 'ดูรายชื่อผู้เข้าร่วมทั้งหมด') {
            memberGraph()
        } else if (textContent == 'คัดกรองผู้เข้าร่วมโครงการ') {
            navigate('/participantScreening', { state: { code: projectDetail['project_code'], name: projectDetail['project_name'], year: year_ } })
        } else {
            setOpenModalContact(true)
        }
        setAnchorEl(null);
    };

    useEffect(() => {
        dispatch(menuActive('งานสร้างเสริม'))
    }, [])

    useEffect(() => {
        projectYear()
    }, [])

    useEffect(() => {
        project()
    }, [year_])

    const project = async () => {
        setLoading(true)
        let res = await api.project(year_, search, null)
        setLoading(false)
        if (res) {
            if (res['data']['code'] === 200) {
                let data = res['data']['data']
                setProjectList(data)
            } else if (res['data']['code'] === 999) {
                console.log(res['data']['message'])
                setProjectList([])
            } else {
                setProjectList([])
                //alert(res['data']['message'])
            }
        } else {
            alert('ไม่ตอบสนอง')
        }
    }

    const toggle = async (code) => {
        setLoading(true)
        let res = await api.toggle(code)
        setLoading(false)
        if (res) {
            if (res['data']['code'] === 200) {
                //alert(res['data']['message'])
                project()
            } else {
                //alert(res['data']['message'])
            }
        } else {
            alert('ไม่ตอบสนอง')
        }
    }

    const projectYear = async () => {
        setLoading(true)
        let res = await api.projectYear()
        setLoading(false)
        if (res) {
            if (res['data']['code'] === 200) {
                let data = res['data']['data'].sort((a, b) => b.value - a.value)
                setOptionYear(data)
            } else if (res['data']['code'] === 999) {
                console.log(res['data']['message'])
            } else {
                //alert(res['data']['message'])
            }
        } else {
            alert('ไม่ตอบสนอง')
        }
    }

    const memberGraph = async () => {
        setLoading(true)
        let res = await api.memberGraph(projectDetail['project_code'], null, null)
        setLoading(false)
        if (res) {
            if (res['data']['code'] == '200') {
                let data = res['data']['data']['graph']
                navigate('/listOfAllParticipants', { state: { code: projectDetail['project_code'], name: projectDetail['project_name'], year: year_, targetList: data['field_list'], date: projectDetail['created_date'] } })
            } else {
                //alert(res['data']['message']);
            }
        } else {
            alert("ไม่ตอบสนอง");
        }
    }

    const handleClickSearch = () => {
        project()
    }

    const handleFilterYear = (e) => {
        let { value } = e.target
        setYear_(value)
    }

    const handleClickToggle = (code) => {
        toggle(code)
    }

    return (
        <>
            {openModalContact ?
                <ModalContactPromoter
                    role={role}
                    onClose={() => { setOpenModalContact(false) }}
                />
                : null
            }
            <Loader loading={loading} />
            <Box sx={{ display: 'grid', gridGap: '10px' }}>
                <Box sx={{
                    fontWeight: 600,
                    color: "#478F96",
                    "@media (max-width: 800px)": {
                        textAlign: "center",
                    },
                }}>จัดการงานสร้างเสริมสุขภาพ</Box>
                <Box sx={{
                    "@media (max-width: 800px)": {
                        textAlign: "center",
                    },
                }}>สร้างโครงการติดตามสุขภาพกำลังพลในกลุ่มต่าง ๆ เพื่อการเฝ้าระวังสุขภาพกำลังพล สำนักงานปลัดกระทรวงกลาโหม</Box>

                <Box sx={{
                    fontWeight: 600,
                    "@media (max-width: 800px)": {
                        textAlign: "center",
                    },
                }}>ค้นหาชื่อโครงการ</Box>
                <Box sx={{
                    border: '1px solid #478F96',
                    borderRadius: '10px',
                    display: 'flex',
                    padding: '5px'
                }}>
                    <TextField
                        fullWidth
                        variant="standard"
                        sx={{
                            ...InputCSS
                        }}
                        InputProps={{
                            disableUnderline: true,
                        }}
                        placeholder="พิมพ์ข้อความเพื่อค้นหาข้อมูล..."
                        value={search}
                        onChange={(e) => { setSearch(e.target.value) }}
                    />
                    <Button variant='contained' onClick={() => { handleClickSearch() }}>ค้นหา</Button>
                </Box>

                <Box sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    "@media (max-width: 800px)": {
                        display: 'grid',
                        gridGap: '10px',
                        justifyContent: 'center'
                    }
                }}>
                    <Box>
                        <Select
                            size="small"
                            sx={{ ...SelectCss }}
                            value={year_}
                            onChange={(e) => { handleFilterYear(e) }}
                        >
                            {optionYear.map((i, idx) => (
                                <MenuItem key={idx} value={i['value']}>{i['label']}</MenuItem>
                            ))}
                        </Select>
                    </Box>
                    {auth.permission.group_code !== 'G-17' &&
                        <Box sx={{
                            "@media (max-width: 800px)": {
                                display: 'grid',
                                justifyContent: 'center'
                            }
                        }}>
                            <Button
                                variant='contained'
                                onClick={() => { navigate('/addProjectPromote') }}
                                sx={{ display: 'flex', gridGap: '10px' }}
                            >
                                <img style={{ width: '20px' }} src={add} />
                                <Box>เพิ่มโครงการ</Box>
                            </Button>
                        </Box>
                    }
                </Box>

                <Box sx={{
                    display: 'grid',
                    gridTemplateColumns: '1fr 1fr 1fr',
                    gridGap: '10px',
                    "@media (max-width: 1000px)": {
                        gridTemplateColumns: '1fr 1fr',
                    },
                    "@media (max-width: 600px)": {
                        gridTemplateColumns: '1fr',
                    }
                }}>
                    {projectList.map((item, index) => (
                        <Box sx={{
                            border: '1px solid #2F327D1A',
                            boxShadow: '2px 2px 10px #2F327D1A',
                            backgroundColor: '#ffffff',
                            borderRadius: '10px',
                            padding: '10px',
                            fontSize: '14px',
                            width: '100%',
                            display: 'flex',
                            flexDirection: 'column'
                        }} key={index}>
                            <Box sx={{
                                height: '200px',
                                "@media (max-width: 1000px)": {
                                    height: '150px',
                                }
                            }}>
                                <img src={item['project_image']} style={{ width: '100%', borderRadius: '10px', height: 'inherit', objectFit: 'cover' }} />
                            </Box>

                            <Box sx={{ display: 'flex', gridGap: '10px', alignItems: 'center' }}>
                                <img src={person} />
                                <Box sx={{ fontSize: '14px' }}>ผู้เข้าร่วมโครงการ {item['participants_total']} คน</Box>
                            </Box>

                            <Box>
                                <Box sx={{ fontWeight: 600 }} className={styles.ellipsis}>{item['project_name']}</Box>
                                <Box className={styles.ellipsis}>{item['project_detail']}</Box>
                            </Box>

                            <Box sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column', justifyContent: 'end' }}>
                                <Box sx={{
                                    display: 'flex',
                                    justifyContent: 'end',
                                    gridGap: '10px',
                                    height: '40px',
                                }}>
                                    <FormControlLabel
                                        control={
                                            <IOSSwitch
                                                checked={item['doc_status_name'] === 'Active' ? true : false}
                                                onChange={() => { handleClickToggle(item['project_code']) }}
                                            />
                                        }
                                    />
                                    <hr style={{ border: '1px solid #AEB4DD' }} />
                                    <>
                                        <IconButton
                                            aria-label="more"
                                            id="long-button"
                                            aria-controls={open ? 'long-menu' : undefined}
                                            aria-expanded={open ? 'true' : undefined}
                                            aria-haspopup="true"
                                            onClick={(event) => { handleClick(event, item) }}
                                        >
                                            <MoreVertIcon />
                                        </IconButton>
                                        <Menu
                                            id="long-menu"
                                            MenuListProps={{
                                                'aria-labelledby': 'long-button',
                                            }}
                                            anchorEl={anchorEl}
                                            open={open}
                                            onClose={handleClose}
                                            slotProps={{
                                                paper: {
                                                    style: {
                                                        minHeight: ITEM_HEIGHT * 4.5,
                                                        width: '25ch',
                                                        boxShadow: '0px 5px 10px rgba(168, 168, 168, 0.1)',
                                                    },
                                                },
                                            }}
                                        >
                                            {auth.permission.group_code == 'G-17' ?
                                                (
                                                    optionsPromote.map((option) => (
                                                        <MenuItem key={option} onClick={handleClickOption}>
                                                            {option}
                                                        </MenuItem>
                                                    ))
                                                )
                                                :
                                                (
                                                    optionsAdmin.map((option) => (
                                                        <MenuItem key={option} onClick={handleClickOption}>
                                                            {option}
                                                        </MenuItem>
                                                    ))
                                                )
                                            }

                                        </Menu>
                                    </>
                                </Box>

                            </Box>
                        </Box>

                    ))}
                </Box>

            </Box>
        </>
    )
}

export default ManagePromote

const SelectCss = {
    backgroundColor: '#C8EBEB',
    border: 'none',
    '.MuiOutlinedInput-notchedOutline': {
        borderColor: '#C8EBEB',
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
        borderColor: '#C8EBEB',
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
        borderColor: '#C8EBEB',
    },
}

const InputCSS = {
    padding: '5px',
    border: 'none',
    '&.MuiInputBase-root': {
        border: 'none'
    },
    '&.MuiInputBase-root:focus': {

    }
}

const IOSSwitch = styled((props) => (
    <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
    width: 42,
    height: 26,
    padding: 0,
    '& .MuiSwitch-switchBase': {
        padding: 0,
        margin: 2,
        transitionDuration: '300ms',
        '&.Mui-checked': {
            transform: 'translateX(16px)',
            color: '#fff',
            '& + .MuiSwitch-track': {
                backgroundColor: '#478F96',
                opacity: 1,
                border: 0,
                ...theme.applyStyles('dark', {
                    backgroundColor: '#478F96',
                }),
            },
            '&.Mui-disabled + .MuiSwitch-track': {
                opacity: 0.5,
            },
        },
        '&.Mui-focusVisible .MuiSwitch-thumb': {
            color: '#478F96',
            border: '6px solid #fff',
        },
        '&.Mui-disabled .MuiSwitch-thumb': {
            color: theme.palette.grey[100],
            ...theme.applyStyles('dark', {
                color: theme.palette.grey[600],
            }),
        },
        '&.Mui-disabled + .MuiSwitch-track': {
            opacity: 0.7,
            ...theme.applyStyles('dark', {
                opacity: 0.3,
            }),
        },
    },
    '& .MuiSwitch-thumb': {
        boxSizing: 'border-box',
        width: 22,
        height: 22,
    },
    '& .MuiSwitch-track': {
        borderRadius: 26 / 2,
        backgroundColor: '#E9E9EA',
        opacity: 1,
        transition: theme.transitions.create(['background-color'], {
            duration: 500,
        }),
        ...theme.applyStyles('dark', {
            backgroundColor: '#39393D',
        }),
    },
}));
